import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CountdownComponent, CountdownEvent } from 'ngx-countdown';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent {
  @ViewChild('countdown', { static: false }) private countdown: CountdownComponent;

  constructor(private readonly router: Router) {}

  handleTimerEvent(event: CountdownEvent) {
    if (event.action === 'done') {
      this.logout();
    }
  }

  handleNavigationChange() {
    if (this.countdown) this.countdown.restart();
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/'])
  }

}
